import { Link } from 'react-router-dom';
import { productCategories } from '../../../mocks/products';

export default function CategoryGrid() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
            Explore by Category
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4">
            Research-Grade Compounds
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {productCategories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden h-full">
                {/* Gradient Header */}
                <div className={`h-48 bg-gradient-to-br ${category.color} flex items-center justify-center relative overflow-hidden`}>
                  <div className="absolute inset-0 bg-black/10"></div>
                  <i className={`${category.icon} text-7xl text-white relative z-10`}></i>
                </div>

                {/* Content */}
                <div className="p-6 bg-white">
                  <h3 className="text-xl font-bold text-navy-900 mb-2">
                    {category.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3">
                    {category.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">
                      {category.count} Products
                    </span>
                    <span className="text-primary-600 text-sm font-semibold group-hover:translate-x-1 transition-transform inline-flex items-center">
                      View Products
                      <i className="ri-arrow-right-line ml-1"></i>
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}